// extracted by mini-css-extract-plugin
export default {"row":"style_row__aVs9l"};